import Cookies from 'js-cookie'
import { elementReady } from "../utils/ElementReady"
import Modal from 'modal-vanilla/dist/modal'


export default class CookiesConsent {
    constructor() {
        this.modalElement = document.querySelector('#cookie_consent')
        this.paramsModalElement = document.querySelector('#cookie_consent_parameters')
        this.paramsButton = document.querySelector('.js-CookiesConsent_ParamsButton')
        this.acceptAllButton = document.querySelector('.js-CookiesConsent_AcceptAll')
        this.acceptForm = document.querySelector('.js-CookiesConsent_Accept')
        this.acceptButton = document.querySelector('.js-CookiesConsent_AcceptButton')
        this.scripts = document.querySelectorAll('.js-CookiesConsent__Script')
        this.analyticsSwitch = document.querySelector('#cookie_consent_analytics')
        this.cookieName = `cookie_consent`
        this.instances = {
            main : null,
            params : null,
        }
        if (this.modalElement) {
            this.init()
        }

    }
    consent(items=1) {
        Cookies.set(this.cookieName, items, {
            expires : 365 * 10,
            path : `/`,
        })
        if (items === 1) {
            this.setScripts()
        }
    }
    setScripts() {
        this.scripts.forEach(script => {
            script.setAttribute('type', 'application/javascript')
            new Function(script.innerText)()
        })
    }
    instantiateModals() {
        this.instances.main = new Modal({
            el: this.modalElement,
            backdrop: 'static',
            keyboard: false,
        })

        this.instances.params = new Modal({
            el: this.paramsModalElement,
            backdrop: 'static',
            keyboard: false,
        })
    }
    showParams() {
        this.hide('main')
        this.show('params')
        this.acceptButton.focus()
    }
    accept(e) {
        e.preventDefault()
        const acceptAnalytics = this.analyticsSwitch.checked ? 1 : 2
        this.consent(acceptAnalytics)
        this.hide('params')
    }
    acceptAll(e) {
        this.consent(1)
        this.hide('main')
    }
    show(instance) {
        this.instances[instance].show()
    }
    hide(instance) {
        this.instances[instance].hide()
    }
    init() {
        this.instantiateModals()

        this.show('main')

        this.acceptAllButton.focus()

        this.paramsButton.addEventListener(`click`, e => this.showParams())
        this.acceptAllButton.addEventListener(`click`, e => this.acceptAll())
        this.acceptForm.addEventListener(`submit`, e => this.accept(e))
    }
}
